
// ********************************************************************** B2C

export const GET_ALL_B2C_USER = "GET_ALL_B2C_USER"
export const ACTIVE_NEW_USER = "ACTIVE_NEW_USER"

